// ── Muundo wa Ripoti (Report Schema) ────────────────────────────────────
// Kila "bloku" ni kikundi cha maswali. Fomu ya ripoti binafsi inasoma
// bloku hizi na kujijenga yenyewe — hakuna fomu tofauti kwa kila
// programu. Bloku ya CHESS ni ileile kwa programu zote (leo na kesho).
//
// Aina za field: text | textarea | number | select | rating | check

export const CHESS_LEVELS = [
  'Mchipukizi', 'Swala', 'Twiga', 'Tembo', 'Chui', 'Simba',
];

const ATTENDANCE = ['Alihudhuria zote', 'Alihudhuria baadhi', 'Hakuhudhuria'];

export const BLOCKS = {

  // ══ BLOKU YA CHESS — SAWA KWA PROGRAMU ZOTE ══════════════════════════
  chess: {
    label: 'Chess',
    icon: 'chess',
    color: '#14452F',
    shared: true,
    fields: [
      { key: 'chessAttendance', label: 'Mahudhurio ya chess wiki hii', type: 'select', options: ATTENDANCE, required: true },
      { key: 'chessSessions', label: 'Idadi ya session alizohudhuria', type: 'number', min: 0, max: 14 },
      { key: 'chessLevel', label: 'Ngazi yake sasa', type: 'select', options: CHESS_LEVELS, required: true },
      { key: 'chessTopics', label: 'Mada zilizofundishwa wiki hii', type: 'text', placeholder: 'mf. Opening principles, fork, checkmate ya mfalme na rook' },
      { key: 'gamesPlayed', label: 'Michezo aliyocheza', type: 'number', min: 0 },
      { key: 'gamesWon', label: 'Ushindi', type: 'number', min: 0 },
      { key: 'gamesDrawn', label: 'Sare', type: 'number', min: 0 },
      { key: 'gamesLost', label: 'Kushindwa', type: 'number', min: 0 },
      { key: 'ratingNow', label: 'Rating yake (kama ana akaunti)', type: 'number', min: 0 },
      { key: 'rSheria', label: 'Uelewa wa sheria za mchezo', type: 'rating' },
      { key: 'rTactics', label: 'Mbinu (tactics) na mipango', type: 'rating' },
      { key: 'rFocus', label: 'Umakini na uvumilivu bodini', type: 'rating' },
      { key: 'rSport', label: 'Nidhamu na heshima kwa mpinzani', type: 'rating' },
      { key: 'rGrowth', label: 'Maendeleo ya jumla ikilinganishwa na wiki iliyopita', type: 'rating' },
      { key: 'chessComment', label: 'Maoni ya kocha kuhusu chess yake', type: 'textarea', rows: 3 },
    ],
  },

  // ══ BLOKU YA LIFESKILLS — SAWA KWA PROGRAMU ZOTE ═════════════════════
  lifeskills: {
    label: 'Lifeskills',
    icon: 'seedling',
    color: '#00695C',
    shared: true,
    fields: [
      { key: 'lsAttendance', label: 'Mahudhurio ya lifeskills', type: 'select', options: ATTENDANCE, required: true },
      { key: 'lsTopic', label: 'Mada ya lifeskills wiki hii', type: 'text', placeholder: 'mf. Kujithamini, kuweka malengo, kuepuka makundi mabaya' },
      { key: 'lsParticipation', label: 'Ushiriki wake kwenye session', type: 'rating' },
      { key: 'lsBehaviour', label: 'Tabia na nidhamu', type: 'rating' },
      { key: 'lsTeamwork', label: 'Ushirikiano na wenzake', type: 'rating' },
      { key: 'lsComment', label: 'Maoni kuhusu lifeskills', type: 'textarea', rows: 3 },
    ],
  },

  // ══ MSAADA — MTOTO ═══════════════════════════════════════════════════
  shule: {
    label: 'Maendeleo Shuleni',
    icon: 'book',
    color: '#1565C0',
    fields: [
      { key: 'schoolAttendance', label: 'Mahudhurio shuleni', type: 'select', options: ['Kila siku', 'Alikosa siku 1-2', 'Alikosa sana', 'Hajaenda kabisa'] },
      { key: 'schoolPerformance', label: 'Ufaulu kwa jumla', type: 'rating' },
      { key: 'academicNote', label: 'Maendeleo ya masomo (masomo anayofanya vizuri / anayohangaika)', type: 'textarea', rows: 3 },
      { key: 'teacherFeedback', label: 'Maoni ya mwalimu wake', type: 'textarea', rows: 2 },
    ],
  },
  nyumbani: {
    label: 'Nyumbani na Mtaani',
    icon: 'home',
    color: '#6A1B9A',
    fields: [
      { key: 'homeSituation', label: 'Hali ya nyumbani wiki hii', type: 'textarea', rows: 3 },
      { key: 'homeBehaviour', label: 'Tabia akiwa nyumbani/mtaani', type: 'rating' },
      { key: 'healthNote', label: 'Hali ya afya', type: 'text', placeholder: 'mf. Nzuri / alikuwa mgonjwa siku 2' },
      { key: 'needs', label: 'Mahitaji au changamoto zinazohitaji msaada', type: 'textarea', rows: 2 },
    ],
  },

  // ══ MSAADA — MZAZI ═══════════════════════════════════════════════════
  biashara: {
    label: 'Biashara (kwa waliopewa mtaji)',
    icon: 'coin',
    color: '#E65100',
    onlyIf: 'hasCapital',
    onlyIfNote: 'Bloku hii inaonekana tu kwa wazazi waliopewa mtaji.',
    fields: [
      { key: 'businessType', label: 'Biashara anayofanya', type: 'text' },
      { key: 'businessOpen', label: 'Je biashara ilifanya kazi wiki hii?', type: 'select', options: ['Ndiyo, kila siku', 'Baadhi ya siku', 'Haikufanya kazi'] },
      { key: 'salesTrend', label: 'Mwenendo wa mauzo', type: 'select', options: ['Yamepanda', 'Yamesimama palepale', 'Yameshuka'] },
      { key: 'savings', label: 'Akiba aliyoweka wiki hii (TZS)', type: 'number', min: 0 },
      { key: 'businessScore', label: 'Uendeshaji wa biashara kwa jumla', type: 'rating' },
      { key: 'businessChallenges', label: 'Changamoto za biashara', type: 'textarea', rows: 3 },
    ],
  },
  microfinance: {
    label: 'Microfinance (session za ziada)',
    icon: 'card',
    color: '#00838F',
    fields: [
      { key: 'mfAttendance', label: 'Mahudhurio ya session ya microfinance', type: 'select', options: ATTENDANCE },
      { key: 'mfTopic', label: 'Mada ya microfinance', type: 'text', placeholder: 'mf. Kuweka kumbukumbu za mauzo, akiba, mikopo' },
      { key: 'mfUnderstanding', label: 'Uelewa wake wa mada', type: 'rating' },
      { key: 'mfApplied', label: 'Je ameanza kutumia aliyofundishwa?', type: 'select', options: ['Ndiyo, wazi kabisa', 'Kidogo', 'Bado'] },
      { key: 'mfComment', label: 'Maoni', type: 'textarea', rows: 2 },
    ],
  },
  binafsi: {
    label: 'Maendeleo Binafsi',
    icon: 'user',
    color: '#AD1457',
    fields: [
      { key: 'personalGoal', label: 'Lengo lake binafsi kwa sasa', type: 'text' },
      { key: 'personalProgress', label: 'Maendeleo kuelekea lengo hilo', type: 'rating' },
      { key: 'familyNote', label: 'Hali ya familia na malezi ya watoto', type: 'textarea', rows: 2 },
      { key: 'personalComment', label: 'Maoni mengine', type: 'textarea', rows: 2 },
    ],
  },

  // ══ USA RIVER YDC — KIJANA ═══════════════════════════════════════════
  kijana: {
    label: 'Maendeleo ya Kijana',
    icon: 'flag',
    color: '#4527A0',
    fields: [
      { key: 'centreAttendance', label: 'Mahudhurio kituoni', type: 'select', options: ATTENDANCE },
      { key: 'engagement', label: 'Ushiriki na motisha yake', type: 'rating' },
      { key: 'goalNote', label: 'Malengo yake na mipango ya baadaye', type: 'textarea', rows: 3 },
      { key: 'lifeChallenges', label: 'Changamoto anazopitia', type: 'textarea', rows: 2 },
      { key: 'referral', label: 'Je anahitaji msaada wa ziada? (elekeza wapi)', type: 'text' },
    ],
  },
};

// ── Field za juu zinazokuwepo kwenye KILA ripoti binafsi ───────────────
// Maswali ya juu yanakusanya namba na alama. Hapa ndipo staff anaeleza
// UHALISIA kwa maneno yake — kile ambacho namba haziwezi kukieleza.
export const COMMON_FIELDS = [
  {
    key: 'summary',
    label: 'Hali halisi — eleza kwa maneno yako mwenyewe',
    type: 'textarea', rows: 6, required: true,
    placeholder: 'Andika kama unavyomweleza mwenzako: alichofanya wiki hii, kilichobadilika, kilichokushangaza, hali yake ilivyokuwa. Usijali sarufi — ukweli ndio muhimu.',
  },
  {
    key: 'context',
    label: 'Kitu chochote muhimu ambacho maswali hapo juu hayakukigusa',
    type: 'textarea', rows: 3,
    placeholder: 'mf. tatizo la nyumbani, jambo la kufurahisha, kitu unachohisi uongozi unapaswa kujua.',
  },
  { key: 'recommendation', label: 'Ushauri / hatua zinazofuata', type: 'textarea', rows: 3 },
];

// ── Ripoti ya session / tukio ──────────────────────────────────────────
export const SESSION_FIELDS = [
  { key: 'topicChess', label: 'Mada ya chess iliyofundishwa', type: 'text' },
  { key: 'topicLifeskills', label: 'Mada ya lifeskills', type: 'text' },
  { key: 'topicExtra', label: 'Mada ya ziada (mf. microfinance)', type: 'text' },
  { key: 'howItWent', label: 'Session ilikuwaje kwa jumla? — eleza uhalisia kwa maneno yako', type: 'textarea', rows: 6, required: true, placeholder: 'Walivyoitikia, hali ya siku hiyo, kilichofanya kazi na kisichofanya kazi.' },
  { key: 'wins', label: 'Mafanikio / vitu vizuri vilivyotokea', type: 'textarea', rows: 3 },
  { key: 'challenges', label: 'Changamoto zilizojitokeza', type: 'textarea', rows: 3 },
  { key: 'materials', label: 'Vifaa vilivyotumika / vinavyohitajika', type: 'text' },
  { key: 'nextPlan', label: 'Mpango wa session ijayo', type: 'textarea', rows: 2 },
  { key: 'context', label: 'Kingine chochote muhimu', type: 'textarea', rows: 3 },
];

// ── Ripoti binafsi ya staff (wiki) ─────────────────────────────────────
export const STAFF_WEEKLY_FIELDS = [
  { key: 'weekSummary', label: 'Wiki yako ilikuwaje kwa ujumla?', type: 'textarea', rows: 4, required: true },
  { key: 'achievements', label: 'Mafanikio / faida ulizoziona', type: 'textarea', rows: 3 },
  { key: 'challenges', label: 'Changamoto ulizokutana nazo', type: 'textarea', rows: 3 },
  { key: 'observations', label: 'Vitu ulivyoviona (observations) ukiwa field', type: 'textarea', rows: 3 },
  { key: 'plansNextWeek', label: 'Mipango yako kwa wiki ijayo', type: 'textarea', rows: 3, required: true },
  { key: 'needsSupport', label: 'Msaada unaohitaji kutoka kwa uongozi', type: 'textarea', rows: 2 },
];

export const RATING_LABELS = ['—', 'Hafifu', 'Chini ya wastani', 'Wastani', 'Vizuri', 'Bora sana'];

// Hesabu asilimia ya ukamilifu wa fomu (kwa progress bar)
export function completionOf(form, fields) {
  const all = fields.filter(f => f.type !== 'check');
  if (!all.length) return 100;
  const filled = all.filter(f => {
    const v = form[f.key];
    return v !== undefined && v !== '' && v !== null && v !== 0;
  });
  return Math.round((filled.length / all.length) * 100);
}

// Kusanya field zote za ripoti binafsi kwa mwanachama fulani
export function fieldsForBlocks(blockIds, member) {
  const out = [];
  blockIds.forEach(id => {
    const b = BLOCKS[id];
    if (!b) return;
    if (b.onlyIf && member && !member[b.onlyIf]) return;
    out.push(...b.fields);
  });
  return out;
}
